// src/user/WithdrawalHistory.js
import React, { useEffect, useState } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import api from '../utils/axiosInstance';
import { API } from '../config/apiConfig';

function WithdrawalHistory() {
  const [withdrawals, setWithdrawals] = useState([]);

  useEffect(() => {
    api.get(API.withdrawals)
      .then((res) => setWithdrawals(res.data))
      .catch((err) => console.error('Error loading withdrawals:', err));
  }, []);

  return (
    <div>
      <Typography variant="h6">Withdrawal History</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {withdrawals.map((w, idx) => (
            <TableRow key={idx}>
              <TableCell>{w.date}</TableCell>
              <TableCell>{w.amount}</TableCell>
              <TableCell>{w.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default WithdrawalHistory;
